import { ProcessingOverlay, SettingsSection } from '@components'

import { Button, Color, FormItemsGroup, Input } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { usePhoneDialCodePlaceholder } from '../../../../../../../../hooks/usePhoneDialCodePlaceholder'
import { useUserProfileForm } from '../../../../hooks/useUserProfileForm'
import * as Styled from './styles'

export const ProfileInfoForm = () => {
  const { t } = useTranslation()
  const { isLoading: isLoadingOrganization } = useUserOrganization()
  const {
    Form,
    FormItem,
    isLoading: isLoadingForm,
    isEmailChangeAllowed,
    isSubmitting: isProcessing,
  } = useUserProfileForm()
  const phoneDialCodePlaceholder = usePhoneDialCodePlaceholder()

  const isLoading = isLoadingForm || isLoadingOrganization

  return (
    <SettingsSection>
      <Form>
        <SettingsSection.RowsContainer>
          <SettingsSection.Content title={t('settings.user.user_settings')}>
            <Styled.FormFieldsWrapper>
              {(isLoading || isProcessing) && <ProcessingOverlay color={Color.White} />}
              <FormItemsGroup>
                <FormItem
                  label={t('settings.user.full_name')}
                  name="name"
                  render={({ field }) => <Input {...field} />}
                />
                <FormItem
                  label={t('settings.user.email_address')}
                  name="email"
                  render={({ field }) => <Input {...field} disabled={!isEmailChangeAllowed} />}
                />
                <FormItem
                  label={t('settings.user.phone_number')}
                  name="phone"
                  render={({ field }) => <Input {...field} placeholder={phoneDialCodePlaceholder} />}
                />
              </FormItemsGroup>
            </Styled.FormFieldsWrapper>
          </SettingsSection.Content>
        </SettingsSection.RowsContainer>
        <SettingsSection.Footer>
          <Button loading={isLoading || isProcessing} size="md" type="submit">
            {t('settings.user.profile.save_changes')}
          </Button>
        </SettingsSection.Footer>
      </Form>
    </SettingsSection>
  )
}
